import { render, staticRenderFns } from "./ModalListTagihanCustomer.vue?vue&type=template&id=52a0e0fc&"
import script from "./ModalListTagihanCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalListTagihanCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports